import SiteTemplate from '@/templates/site-interno/SiteTemplate'
import Login from '@/pages/auth/Login'
import RedirectCliente from '@/pages/auth/RedirectCliente'
import RecuperarSenha from '@/pages/auth/RecuperarSenha'
import AlterarSenha from '@/pages/auth/AlterarSenha'
// eslint-disable-next-line no-unused-vars
import HomeExterna from '@/pages/site/externa/Home'
import HomeInterna from '@/pages/site/interna/Home'
import Usuario from '@/pages/site/interna/administrador/usuarios/Usuarios'
import UsuarioEditar from '@/pages/site/interna/administrador/usuarios/UsuarioEditar'
import UsuarioCadastrar from '@/pages/site/interna/administrador/usuarios/UsuarioCadastrar'
import SistemasClientes from '@/pages/site/interna/administrador/sistemas/SistemasClientes'
import CadastrarSistemasClientes from '@/pages/site/interna/administrador/sistemas/CadastrarSistemasClientes'
import Questionarios from '@/pages/site/interna/cliente/questionarios/Questionarios'
import CadastrarQuestionarios from '@/pages/site/interna/cliente/questionarios/CadastrarQuestionarios'
import RespostasQuestionarios from '@/pages/site/interna/cliente/questionarios/RespostasQuestionarios'
import VisualizarDestinatarios from '@/pages/site/interna/cliente/questionarios/VisualizarDestinatarios'
import ResponderQuestionarios from '@/pages/site/externa/ResponderQuestionarios'
import VisualizarImpressaoQuestionario from '@/pages/site/externa/VisualizarImpressaoQuestionario'
import Mensagem from '@/pages/site/externa/Mensagem'
import PublicarQuestionarios from '@/pages/site/interna/cliente/questionarios/PublicarQuestionarios'
import DadosCliente from '@/pages/site/interna/cliente/perfil/DadosCliente'
import MeuPerfil from '@/pages/site/interna/perfil/MeuPerfil'

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Página Inicial',
    component: SiteTemplate,
    children: [
      {
        path: '/',
        component: HomeInterna
      },
      {
        path: '/usuarios',
        name: 'Usuários',
        component: Usuario
      },
      {
        path: '/usuario/:id/visualizar',
        name: 'Visualizar Usuário',
        component: UsuarioEditar
      },
      {
        path: '/usuario/:id/editar',
        name: 'Alterar Usuário',
        component: UsuarioEditar
      },
      {
        path: '/usuario/cadastrar',
        name: 'Cadastrar Usuário',
        component: UsuarioCadastrar
      },
      {
        path: '/perfil',
        name: 'Meu Perfil',
        component: MeuPerfil
      },
      {
        path: '/sistemas',
        name: 'Sistemas Clientes',
        component: SistemasClientes
      },
      {
        path: '/sistema/cadastrar',
        name: 'Cadastrar Sistema Cliente',
        component: CadastrarSistemasClientes
      },
      {
        path: '/sistema/editar/:id',
        name: 'Editar Sistema Cliente',
        component: CadastrarSistemasClientes
      },
      {
        path: '/sistema/visualizar/:id',
        name: 'Visualizar Sistema Cliente',
        component: CadastrarSistemasClientes
      },
      {
        path: '/dados/visualizar/:id',
        name: 'Visualizar Dados do Sistema',
        component: DadosCliente
      },
      {
        path: '/dados/editar/:id',
        name: 'Alterar Dados do Sistema',
        component: DadosCliente
      },
      {
        path: '/formularios',
        name: 'Formulários',
        component: Questionarios
      },
      {
        path: '/formulario/cadastrar/:id_vinculo?',
        name: 'Cadastro de Formulário',
        component: CadastrarQuestionarios
      },
      {
        path: '/formulario/visualizar/:id',
        name: 'Visualizar Formulário',
        component: ResponderQuestionarios
      },
      {
        path: '/formulario/editar/:id',
        name: 'Edição de Formulário',
        component: CadastrarQuestionarios
      },
      {
        path: '/formulario/duplicar/:id',
        name: 'Duplicar Formulário',
        component: CadastrarQuestionarios
      },
      {
        path: '/formulario/visualizar/estrutura/:id',
        name: 'Visualizar Estrutura do Formulário',
        component: CadastrarQuestionarios
      },
      {
        path: '/formulario/suspender/:id',
        name: 'Suspender Formulário',
        component: CadastrarQuestionarios
      },
      {
        path: '/formulario/publicar/:id',
        name: 'Publicar Formulário',
        component: PublicarQuestionarios
      },
      {
        path: '/formulario/encaminhar/:id',
        name: 'Encaminhar Formulário',
        component: PublicarQuestionarios
      },
      {
        path: '/formulario/respostas/:id',
        name: 'Respostas do Formulário',
        component: RespostasQuestionarios
      },
      {
        path: '/resposta/visualizar/:id',
        name: 'Visualizar Resposta',
        component: ResponderQuestionarios
      },
      {
        path: '/destinatarios/:id',
        name: 'Visualizar Destinatários',
        component: VisualizarDestinatarios
      },
      {
        path: '/resposta/reencaminhar/:id',
        name: 'Reencaminhar Resposta',
        component: PublicarQuestionarios
      }
    ]
  },
  {
    path: '/responder/:token',
    name: 'Responder Formulário',
    component: ResponderQuestionarios
  },
  {
    path: '/resposta/externa-visualizar/:token/:id',
    name: 'Visualizar Resposta',
    component: ResponderQuestionarios
  },
  {
    path: '/formulario/respostas/externa/:id/:external',
    name: 'Visualizar Resposta',
    component: ResponderQuestionarios
  },
  {
    path: '/mensagem',
    name: 'Mensagem Formulário',
    component: Mensagem
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/redirect-cliente/:token/:rota_desejada?/:id_vinculo?',
    name: 'Redirect',
    component: RedirectCliente
  },
  {
    path: '/recuperar-senha',
    component: RecuperarSenha
  },
  {
    path: '/alterar-senha/:token',
    component: AlterarSenha
  },
  // Formularios de integração 
  {
    path: '/formulario-integracao/cadastrar/:id_vinculo?',
    name: 'Cadastro de Formulário',
    component: CadastrarQuestionarios
  },
  {
    path: '/formulario-integracao/visualizar/:id',
    name: 'Visualizar Formulário',
    component: ResponderQuestionarios
  },
  {
    path: '/formulario-integracao/visualizarImpressao/:id',
    name: 'Visualizar Formulário',
    component: VisualizarImpressaoQuestionario
  },
  {
    path: '/formulario-integracao/encaminhar/:id',
    name: 'Encaminhar Formulário',
    component: PublicarQuestionarios
  },
  {
    path: '/formulario-integracao/editar/:id',
    name: 'Edição de Formulário',
    component: CadastrarQuestionarios
  },
  {
    path: '/formulario-integracao/visualizar/estrutura/:id',
    name: 'Visualizar Estrutura do Formulário',
    component: CadastrarQuestionarios
  },
  {
    path: '/formulario-integracao/duplicar/:id/:id_vinculo',
    name: 'Duplicar Formulário',
    component: CadastrarQuestionarios
  },
  {
    path: '/formulario-integracao/respostas/:id',
    name: 'Respostas do Formulário',
    component: RespostasQuestionarios
  },
  {
    path: '/formulario-integracao/resposta/visualizar/:id',
    name: 'Visualizar Resposta',
    component: ResponderQuestionarios
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js